export const groupStyles = (props: any) => {
	const _vertical = props.orientation == 'vertical' ? {
		flexDirection: 'column',
		display: 'inline-flex',
		alignItems: 'stretch',
	} : {
		flexDirection: 'row',
		display: 'flex',
		alignItems: 'center',
	}
	return {
		columnGap: props.columnGap || '0px',
		height: props.labeled ? '85px' : 'auto',
		..._vertical
	};
};

export const sizeMiniWidth = (props: any, itemProps: any) => {
	return props.size === 'mini' && !itemProps.children
		? {
			maxWidth: 'var(--epods--button-mini-height)',
			minWidth: 'var(--epods--button-mini-height)',
			width: 'var(--epods--button-mini-height)',
		}
		: {};
};

export const firstButtonStyles = (theme: string = '') => ({
	marginRight: '0px !important',
	marginLeft: '0px !important',
});

export const buttonBaseStyles = (theme: string = '', orientation: string = 'horizontal') => {

	if (orientation == 'vertical') {
		return theme === 'secondary' || theme === 'tertiary' || theme === 'toggle'
			? {
				marginTop: '-1px !important',
				marginRight: '0px !important',
				marginLeft: '0px !important',
				marginBottom: '0px !important',
			}
			: {
				marginTop: '1px !important',
				marginRight: '0px !important',
				marginLeft: '0px !important',
				marginBottom: '0px !important',
			}
	}

	return theme === 'secondary' || theme === 'tertiary' || theme === 'toggle'
		? {
			marginLeft: '-1px !important',
			marginRight: '0px !important',
			marginTop: '0px !important',
			marginBottom: '0px !important',
		}
		: {
			marginLeft: '1px !important',
			marginRight: '0px !important',
			marginTop: '0px !important',
			marginBottom: '0px !important',
		}
};
